import React from 'react';
import classNames from 'classnames';
import { Button, ButtonProps } from 'src/common/button';

interface OnboardingButtonProps extends Omit<ButtonProps, 'variant'> {
  className?: string;
  variant?: ButtonProps['variant'];
}

const OnboardingButton: React.FC<OnboardingButtonProps> = ({ 
  className, 
  variant = 'primary',
  ...props 
}) => {
  return (
    <Button
      {...props}
      variant={variant}
      className={classNames(
        'transition-all duration-300 ease-in-out',
        'bg-[#1A1F71] hover:bg-[#2A2F91] active:bg-[#0A0F51]',
        'border-[#1A1F71] hover:border-[#2A2F91] active:border-[#0A0F51]',
        'text-white font-medium',
        'rounded-lg py-3 px-6',
        'focus:ring-2 focus:ring-[#1A1F71] focus:ring-opacity-50',
        'transform hover:-translate-y-0.5 active:translate-y-0',
        className
      )}
    />
  );
};

export default OnboardingButton; 